import {
  BasketballMessagesSlice,
  userActiveBasketballCoachTeamId,
} from '@hefe/store';
import { Button, Form, Input, message, Select, Space } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import EditorComponent from '../../../core/components/editor/editor.component';
import { useSelector } from 'react-redux';

interface MessagesComposerComponentProps {
  mode: 'admin' | 'team' | 'user';
  onCancelClick: () => void;
}

export default function MessagesComposerComponent(
  props: MessagesComposerComponentProps
) {
  const dispatch = useAppDispatch();

  const [saving, setSaving] = useState(false);
  const recipients = useSelector(
    BasketballMessagesSlice.basketballMessageRecipientsSelector
  );

  const activeCoachTeamId = useSelector(userActiveBasketballCoachTeamId);

  useEffect(() => {
    fetchRecipients();
  }, []);

  const fetchRecipients = () => {
    dispatch(
      BasketballMessagesSlice.fetchBasketballMessageRecipients({
        team: props.mode === 'team',
        cacheDuration: 5 * 60 * 1000,
      })
    );
  };
  const saveMessage = (values: any) => {
    setSaving(true);

    dispatch(
      BasketballMessagesSlice.createBasketballMessage({
        adminMessage: props.mode === 'admin',
        text: values.text,
        title: values.title,
        values: values.recipients,
      })
    )
      .unwrap()
      .then(() => props.onCancelClick())
      .finally(() => setSaving(false));
  };

  const initialSelectValue = () => {
    if (props.mode === 'team') {
      if (activeCoachTeamId) {
        return [`t${activeCoachTeamId}`];
      }
    }

    return [];
  };

  const selectRecipients = () => {
    if (recipients) {
      if (props.mode === 'team') {
        return recipients.map((group) => {
          return {
            ...group,
            options: group.options.map((o) => ({
              ...o,
              disabled: o.value === `t${activeCoachTeamId}`,
            })),
          };
        });
      } else {
        return recipients;
      }
    }

    return [];
  };

  return (
    <div>
      <Form onFinish={(values) => saveMessage(values)} labelWrap>
        <Form.Item
          name="title"
          label={t('title')}
          wrapperCol={{ span: 24, offset: 0 }}
          required={true}
          rules={[
            {
              required: true,
              message: t('form_errors.title'),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          initialValue={initialSelectValue()}
          name="recipients"
          label={t('recipients')}
          wrapperCol={{ span: 24, offset: 0 }}
          rules={[
            {
              required: true,
              message: t('form_errors.recipient'),
            },
          ]}
        >
          <Select
            mode="multiple"
            options={selectRecipients()}
            optionFilterProp="children"
            filterOption={(input: string, option: any) => {
              const isGroup = Array.isArray(option.options);
              if (isGroup) {
                return false;
              }
              return option.label.toLowerCase().includes(input.toLowerCase());
            }}
          />
        </Form.Item>
        <Form.Item
          name="text"
          wrapperCol={{ span: 24, offset: 0 }}
          rules={[
            {
              required: true,
              message: t('form_errors.text'),
            },
          ]}
        >
          <EditorComponent />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 24, offset: 0 }}>
          <Space>
            <Button type="primary" htmlType="submit" loading={saving}>
              {t('save')}
            </Button>
            <Button onClick={() => props.onCancelClick()}>{t('cancel')}</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
}
